import { Injectable, computed, signal, inject } from '@angular/core';
import { ScriptInjectorService } from '../script-injector/script-injector.service';
import { environment } from 'src/environments/environment';
import { Page } from '../als-ada/analytics/interfaces';

declare const _satellite: any;
const { LINKS } = environment;
const DATA_LAYER = {
  page: {
    pageInfo: {
      pageName: 'MX|BNP|Dashboard',
      breadcrumbs: 'Login Access',
      pageType: 'Dashboard',
      channel: 'BMX',
    },
    userInfo: {},
    pageInstanceId: '',
    eventList: '',
    category: {
      pageCategory: 'Dashboard',
    },
    attributes: {
      country: 'MX',
      language: 'ES',
    },
  },
};

let DATA_LAYER_ADA = {
	page: {
		pageInfo: {
			pageName: "MX|BNP|Detalle_Productos",
			breadcrumbs: "login , dashboard",
			pageType: "Detalle",
			prodNameOrig: "CodigoDelProducto",
			transactionDetail: "Estatus",
			campaignDetail: "NombreCampaña",
			channel: "BMX",
			server: "server-code",
		},
		pageInstanceId: "Citibanamex - Sitio Publico", 
		category: {
			pageCategory: "CreditosNomina",

		},
		attributes: {
			country: "MX",
			language: "ES"
		}
	}
}

@Injectable({
  providedIn: 'root',
})
export class AdobeAnalyticsService {
  private scriptInjectorService = inject(ScriptInjectorService);

  public dashboardContainerCompleted = signal<boolean | null>(null);
  public accounListCompleted = signal<boolean | null>(null);

  completedData = computed(() => this.dashboardContainerCompleted() !== null && 
  this.accounListCompleted() !== null);

  
  initAdobeLaunchDataLayer() {
    console.log('[INIT ADOBE] ALservice->');

    (window as any).digitalData = DATA_LAYER;
  }
  
  initAdobeLaunchDataLayerADA(){
    (window as any).digitalData = DATA_LAYER_ADA; 
  }

  async injectAdobeLaunchScript() {
    console.log('[INJCT ADOBE] ALservice->');
    try {
      await this.scriptInjectorService.load(
        'launch',
        LINKS.ADOBE_LAUNCH_URL,
      );
      await this.scriptInjectorService.load(
        'launch-migration',
        LINKS.ADOBE_LAUNCH_MIGRATION_URL,
      );

      _satellite.pageBottom();
    } catch (e) {
      console.log('Error while loading Adobe Launch script', e);
    }
  }

  overrideDataLayer({ key, value }: { key: string, value: any }): void {

  }

  pageInteraction(accion: string, pageName: string) {
    if ((window as any).digitalData.event) {
      (window as any).digitalData.event.push({
        eventName: 'Page Interaction',
        eventAction: 'pageInteraction',
        attributes: {
          pageInteraction: `${pageName}|${accion}`,
        },
        type: 'interaction',
        timeStamp: new Date(),
      });
    } else {
      return;
    }
  }

  downloadPDF(accion: string, pageName: string, url: string) {
    if ((window as any).digitalData.event) {
      (window as any).digitalData.event.push({
        eventName: 'Download PDF',
        eventAction: 'DownloadPDF',
        attributes: {
          downloadName: `${pageName}|${accion}`,
          downloadURL: url,
        },
        type: 'interaction',
        timeStamp: new Date(),
      });
    } else {
      return;
    }
  }

  /**
   *
   * @param prodNameOrig Coloca el valor del analitico
   * @returns metodo vacio para colocar analitico
   */
  setProdOrigin(prodNameOrig: any): void {
    if ((window as any).digitalData.page)
      (window as any).digitalData.page.pageInfo.prodNameOrig = prodNameOrig
    return
  }

  /**
   *
   * @param campaignDetail Coloca el valor del analitico
   * @returns metodo vacio para colocar analitico
   */
  setCampaignDetail(campaignDetail: any): void {
    if ((window as any).digitalData.page)
      (window as any).digitalData.page.pageInfo.campaignDetail = campaignDetail
    return
  }

  /**
   *
   * @param transactionDetail Coloca el valor del analitico
   * @returns metodo vacio para colocar analitico
   */
  setTransactionDetail(transactionDetail: any): void {
    if ((window as any).digitalData.page)
      (window as any).digitalData.page.pageInfo.transactionDetail = transactionDetail
    return
  }

  /**
   *
   */
  setPageCategory(pageCategory: string): void {
    if ((window as any).digitalData.page)
      (window as any).digitalData.page.category.pageCategory = pageCategory
    return
  }
  /**
   *
   * @param name Tipo de variable o propiedad
   * @param value Valor del analitico
   * @returns metodo para validar analitico
   */
  setPropAndEvar(name: string, value: any): void {
    if (!(<any>window).digitalData.event)
      (<any>window).digitalData.event = []
    try {
      if ((<any>window).digitalData.event)
        (<any>window).digitalData.event.push({
          eventName: 'Set Evar Ada',
          eventAction: 'setEvarAda',
          attributes: {
            [name]: `${value}`,
          },
          type: 'interaction',
          timeStamp: new Date(),
        })
      else
        return console.error('Error setEvarADA')
    } catch (error) {
      console.error(error, 'analíticos setEvarADA')
    }
  }

  /**
   *
   * @param pageName Nombre de la pagina.
   * @returns Agrega el nombre de la pagina en el ananlitico.
   */
  updatePageView(page: Page ): void {
    (window as any).digitalData = {
        ...(window as any).digitalData,
        page
    }
    if (!(<any>window).digitalData.event)
      (<any>window).digitalData.event = []

    try {
      if ((<any>window).digitalData.event)
        (<any>window).digitalData.event.push({
          eventName: 'Udpate Page View',
          eventAction: 'updatePageView',
          attributes: {
            pageName: `${page.pageInfo?.pageName}`,
          },
          type: 'interaction',
          timeStamp: new Date(),
        })
      return console.error('Error updatePageView ')
    } catch (error) {
      console.error(error, 'analíticos updatePageView')
    }
  }

  setUserId(userId: string) {
    if ((window as any).digitalData.page) {
      (window as any).digitalData.page.userInfo.userId = userId;
    } else {
      return;
    }
  }

  setCustType(custType: string) {
    if ((window as any).digitalData.page) {
      (window as any).digitalData.page.userInfo.customerType = custType;
    } else {
      return;
    }
  }

  setAccountCategory(accountCategory: string) {
    if ((window as any).digitalData.page) {
      (window as any).digitalData.page.userInfo.accountCategory = accountCategory;
    } else {
      return;
    }
  }

  setCitiProducts(citiProducts: string) {
    if ((window as any).digitalData.page) {
      (window as any).digitalData.page.userInfo.citiProducts = citiProducts;
    } else {
      return;
    }
  }

  setAccountProducts(accountProducts: string) {
    if ((window as any).digitalData.page) {
      (window as any).digitalData.page.userInfo.accountProducts =
        accountProducts;
    } else {
      return;
    }
  }

  setCategoriesNames(categoriesNames: string) {
    if ((window as any).digitalData.page) {
      (window as any).digitalData.page.userInfo.categoriesNames =
        categoriesNames;
    } else {
      return;
    }
  }

  setServer(server: string) {
    if ((window as any).digitalData.page) {
      (window as any).digitalData.page.attributes.server = server;
    } else {
      return;
    }
  }

  setProdOfferType(prodOfferType: string) {
    if ((window as any).digitalData.page) {
      (window as any).digitalData.page.userInfo.prodOfferType = prodOfferType;
    } else {
      return;
    }
  }

  setEventLoginSuccess() {
    if ((window as any).digitalData.page) {
      (window as any).digitalData.page.eventList = 'event2';
    } else {
      return;
    }
  }

  // Pagare y fondos de inversión
  newPageload() {
    if ((window as any).digitalData.event) {
      (window as any).digitalData.event.push({
        eventName: 'New page Load',
        eventAction: 'newPageload',
        type: 'load',
        timeStamp: new Date(),
      });
    } else {
      return;
    }
  }
//General Error ADA Credits ALS
  generalErrorADACreditsAls( page: Page, mensaje:string, servicio: string) {
    (window as any).digitalData = {
        ...(window as any).digitalData,
        page
    }
    if ((window as any).digitalData.event) {
      (window as any).digitalData.event.push({
        eventName: 'General Error',
        eventAction: 'generalErrorADACreditsAls',
        attributes: {
          mensaje,
          servicio
        },
        type: 'Error',
        timeStamp: new Date(),
      });
    } else {
      return;
    }
  }

  generalError(mensaje: string, servicio: any, campo: string) {
    if ((window as any).digitalData.event) {
      (window as any).digitalData.event.push({
        eventName: 'General Error',
        eventAction: 'generalError',
        attributes: {
          servicio,
          campo,
          mensaje,
        },
        type: 'Error',
        timeStamp: new Date(),
      });
    } else {
      return;
    }
  }

  generalTransactionStep2() {
    if ((window as any).digitalData.event) {
      (window as any).digitalData.event.push({
        eventName: 'Self Service Step 2',
        eventAction: 'selfServiceStep2',
        attributes: {},
        type: 'Self Service',
        timeStamp: new Date(),
      });
    } else {
      return;
    }
  }

  generalTransactionStart(transaction: any, type: any) {
    if ((window as any).digitalData.event) {
      (window as any).digitalData.event.push({
        eventName: 'Self Service Start',
        eventAction: 'selfServiceStart',
        attributes: {
          transaction,
          type,
        },
        type: 'Self Service',
        timeStamp: new Date(),
      });
    } else {
      return;
    }
  }

  generalTransactionComplete = function (
    origen: string,
    destino: string,
    horario: 'Programado' | 'Ahora',
    estatus: string,
    moneda: string,
    rango: string,
    transaction: string,
    type: string,
  ) {
    if ((window as any).digitalData.event) {
      (window as any).digitalData.event.push({
        eventName: 'Self Service Complete',
        eventAction: 'selfServiceComplete',
        attributes: {
          origen,
          destino,
          horario,
          estatus,
          moneda,
          rango,
          transaction,
          type,
        },
        type: 'Registration',
        timeStamp: new Date(),
      });
    } else {
      return;
    }
  };

  modalInteraction(
    action: string,
    modalName: string,
    modalType: string,
    propAction: string,
    event?: any,
  ) {
    (window as any).digitalData.page.pageInfo.modalType = modalType;
    (window as any).digitalData.page.eventList = event;
    if ((window as any).digitalData.event) {
      (window as any).digitalData.event.push({
        eventName: 'Modal Interaction',
        eventAction: 'modalInteraction',
        attributes: {
          modalInteraction: `${modalName}${action}`,
          customLink: `${modalName}${action}|${propAction}`,
        },
        type: 'interaction',
        timeStamp: new Date(),
      });
    } else {
      return;
    }
    console.log((window as any).digitalData);
  }

  modalTracking(
    modalName: string,
    modalTrack: string,
    action: string,
    event: string,
    pageName: string,
    location: string,
    errorCode?: string,
  ) {
    (window as any).digitalData.page.eventList = event;
    (window as any).digitalData.page.pageInfo.pageName = modalName || location ? `${modalName}${location}|${pageName}` : pageName;
    if ((window as any).digitalData.event) {
      (window as any).digitalData.event.push({
        eventName: 'Modal Tracking',
        eventAction: 'modalTracking',
        attributes: {
          modalTracking: `${modalName}${modalTrack}${action}`,
          ...(errorCode && {
            errorCode: `${modalName}${pageName}|${errorCode}`,
          }),
        },
        type: 'interaction',
        timeStamp: new Date(),
      });
    } else {
      return;
    }
    console.log((window as any).digitalData);
  }

  /**
   * Page view from Dashboard
   *
   * @param data
   */
  setDashboardView(data: any): void {
    const {
      server,
      userId,
      custType,
      citiproducts,
      mainProduct,
      accountCategory,
      categoriesNames,
      accountProducts,
      creditProducts,
      prodOfferType,
      adobeTargetFlg
    } = data
    const _dataLayer = {
      page: {
        pageInfo: {
          pageName: "MX|BNP|Dashboard",
          breadcrumbs: "login",
          pageType: "Dashboard",
          modalType: "ActualizacionAML",
          channel: "BMX",
          server,
          custType, 
          userId,
          SignOnMethod: "Metodo/FormaDeAcceso", // MISSING   
        },
        products: {
          citiproducts,  
          mainProduct,  
          accountCategory,
          categoriesNames,
          accountProducts,
          creditProducts,  
          prodOfferType,  
        },
        pageInstanceId: "Citibanamex - Sitio Publico",
        category: {
          primaryCategory: "Dashboard",
        },
        attributes: {
          country: "MX",
          language: "ES",
          adobeTargetFlg
        }
      }
    }
    if ((window as any).digitalData.page) {
      (window as any).digitalData.page = {..._dataLayer.page};
    }

    if (!(<any>window).digitalData.event) {
      (<any>window).digitalData.event = []
    }

    try {
      if ((<any>window).digitalData.event)
        (<any>window).digitalData.event.push({
          eventName: 'Direct Call - DashboardView',
          eventAction: 'directCallDashboardView',
          type: 'Direct Call',
          timeStamp: new Date(),
        })
      else
        return console.error('Error directCallDashboardView')
    } catch (error) {
      console.error(error, 'analíticos directCallDashboardView')
    }
  }
}
